import { render } from "./AgeGuessingGame.vue?vue&type=template&id=bd4a6084&scoped=true"
import script from "./AgeGuessingGame.vue?vue&type=script&lang=js"
export * from "./AgeGuessingGame.vue?vue&type=script&lang=js"

import "./AgeGuessingGame.vue?vue&type=style&index=0&id=bd4a6084&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd4a6084"]])

export default __exports__